import {IChangeLanguage, IFooterL10n} from "../interface/IFooter";
import ko from './l10n/ko';
import zh_TW from './l10n/zh_TW';
import ja from './l10n/ja';
import en from './l10n/en';
import th from './l10n/th';
import ru from './l10n/ru';
import id from './l10n/id';
import ar from './l10n/ar';

import de from './l10n/de';
import fr from './l10n/fr';
import it from './l10n/it';
import es_ES from './l10n/es_ES';
import es_MX from './l10n/es_MX';
import pt from './l10n/pt';
import tr from './l10n/tr';

import hi from './l10n/hi';
import vi from './l10n/vi';

import zh_CN from './l10n/zh_CN';
import pl from './l10n/pl';

export const footerL10n: IFooterL10n = {
    ko: ko,
    zh_TW: zh_TW,
    zh_CN: zh_CN,
    ja: ja,
    en: en,
    th: th,
    ru: ru,
    id: id,
    ar: ar,
    de: de,
    fr: fr,
    it: it,
    es_ES: es_ES,
    es_MX: es_MX,
    pt: pt,
    tr: tr,
    hi: hi,
    vi: vi,
    pl: pl,
};

export const footerL10nLang: IChangeLanguage = {
    ko: "한국어",
    en: "English",
    zh_TW: "中文－繁體",
    zh_CN: "中文－简体",  // [WSD-362]에서 번역은 简体中文 이렇게 받았지만, 그냥 이걸로 씀 
    ja: "日本語",
    ar: "العربية",
    th: "ภาษาไทย",
    id: "Bahasa Indonesia",
    ru: "Русский",
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
    es_ES: 'Español (ES)',
    es_MX: 'Español (LATAM)',
    pt: 'Português (BR)',
    tr: 'Türkçe',
    hi: 'हिन्दी',
    vi: 'Tiếng Việt',
    pl: 'Polski', // [WSD-362]에서 번역은 Angielski 이렇게 받았지만, 그냥 이걸로 씀
};
